export const translation = {
    "uk": {
        "loadMore": "Завантажити ще",
        "selectYourCity": "Оберіть ваше місто",
        "select": "Обрати",
        "iAgree": "Погоджуюсь",
        "iDisagree": "Не погоджуюсь",
        "ok": "Ок",
        "readMore": "Детальніше",
        "confirmPayment": "Підтвердити оплату",
        "uah": "грн",
        "pcs": "шт",
        "selectACustomer": "Виберіть клієнта",
        "customersDeliveryAddress": "Адреса доставки клієнта",
        "continue": "Продовжити",
        "payByCard": "Оплатити карткою",
        "didntFindWhatYouWereLookingFor": "Не знайшли, що шукали?",
        "leaveYourContactsAndOurManagerWillHelpYou": "Залиште свої контакти та наш менеджер вам допоможе.",
        "isThisYourFirstTimeOnTheSite": "Вперше на сайті?",
        "hasAccount": "Маєте акаунт?",
        "login": "Вхід",
        "enterTheCodeFromTheSmsThatWasSentTo": "Введіть код з SMS, який був відправлений на",
        "sendTheCodeAgain": "Відправити код ще раз",
        "iDontHaveAccessToMyPhoneSendCodeToEMail": "В мене немає доступу до телефону відправити код на E-mail",
        "next": "Далі",
        "complete": "Завершити",
        "repeatThePasswordOneMoreTime": "Повторіть пароль ще раз",
        "enterANewPassword": "Введіть новий пароль",
        "youHaveSuccessfullyPassedTheVerificationByEMail": "Введіть новий пароль",
        "youHaveSuccessfullyPassedTheVerificationByPhone": "Ви успішно пройшли перевірку по Телефону",
        "theWebsiteIsCurrentlyBeingFinalized": "Сайт знаходиться на стадії доопрацювання",
        "weApologizeForTheInconvenienceThatMayAriseWhenPlacingAnOrderOnTheSiteAndGive": "Вибачаємось за незручності, які можуть виникнути при оформленні замовлення на сайті та даруємо",
        "10discountOnAllOnlineOrders": "знижку 10% на усі онлайн замовлення",
        "price": "Ціна",
        "show": "Показати",
        "save": "Зберегти",
        "cancel": "Відмінити",
        "priceInDescendingOrder": "Ціна за спаданням",
        "priceInAscendingOrder": "Ціна за зростанням",
        "doNotSort": "Не сортувати",
        "error": "Помилка",
        "unfortunatelysomethingWentWrongyouCanContactTheSupportTeamToFindOutWhy": "На жаль щось пішло не так, для вияснення причини можете звернутись в службу підтримки",
        "tochkaIsABuildingMaterialsStore": "Точка - магазин будівельних матеріалів",
        "category": "Категорії",
        "naturalPerson": "Фізична особа",
        "legalEntity": "Юридична особа",
        "contactPerson": "Контактна особа",
        "aboutTheLegalEntity": "Про юридичну особу",
        "address": "Адреса",
        "delivery": "Доставка",
        "fop_short": "ФОП",
        "legalEntity_short": "Юр. особа",
        "tel": "тел",
        "collapse": "Згорнути",
        "NAME": "ПІБ",
        "productName": "Назва товару",
        "bonuses": "Бонуси",
        "amount": "Сума",
        "totalBonuses": "Всього бонусів",
        "allAboutTheProduct": "Все про товар",
        "promotion": "Акція",
        "recoverByEmail": "Відновити за допомогою email",
        "recoverByPhone": "Відновити за допомогою телефона",
        "days": "Днів",
        "hours": "Годин",
        "minutes": "Хвилин",
        "seconds": "Секунд",
        "thePromotionIsOver": "Акція закінчилась",
        "codeOf6Digits": "Код з 6 цифр",
        "productCatalog": "Каталог товарів",
        "theLatest": "Останні",
        "popular": "Популярні",
        "all": "Всі",
        "acknowledgments": "Подяка",
        "remarks": "Зауваження",
        "contacts": "Контакти",
        "searchAlert": "Для початку пошуку необхідно ввести мінімум 3 символи",
        "youCurrentlyHaveNoArchivedOrders": "Наразі у вас немає архівних замовлень",
        "youCurrentlyHaveNoArchivedOrders": "Наразі у вас немає архівних замовлень",
    },
    "ru": {
        "loadMore": "Загрузить еще",
        "selectYourCity": "Выберите ваш город",
        "select": "Выбрать",
        "iAgree": "Согласен",
        "iDisagree": "Не согласен",
        "ok": "Ок",
        "readMore": "Подробнее",
        "confirmPayment": "Подтвердить оплату",
        "uah": "грн",
        "pcs": "шт",
        "selectACustomer": "Выберите клиента",
        "customersDeliveryAddress": "Адрес доставки клиента",
        "continue": "Продолжить",
        "payByCard": "Оплатить картой",
        "didntFindWhatYouWereLookingFor": "Не нашли, что искали?",
        "leaveYourContactsAndOurManagerWillHelpYou": "Оставьте свои контакты и наш менеджер вам поможет.",
        "isThisYourFirstTimeOnTheSite": "Впервые на сайте?",
        "hasAccount": "Имеете аккаунт?",
        "login": "Вход",
        "enterTheCodeFromTheSmsThatWasSentTo": "Введите код из SMS, который был отправлен на",
        "sendTheCodeAgain": "Отправить код еще раз",
        "iDontHaveAccessToMyPhoneSendCodeToEMail": "У меня нет доступа к телефону отправить код на E-mail",
        "next": "Далее",
        "complete": "Завершить",
        "repeatThePasswordOneMoreTime": "Повторите пароль еще раз",
        "enterANewPassword": "Введите новый пароль",
        "youHaveSuccessfullyPassedTheVerificationByEMail": "Введите новый пароль",
        "youHaveSuccessfullyPassedTheVerificationByPhone": "Вы успешно прошли проверку по Телефону",
        "theWebsiteIsCurrentlyBeingFinalized": "Сайт находится на стадии доработки",
        "weApologizeForTheInconvenienceThatMayAriseWhenPlacingAnOrderOnTheSiteAndGive": "Извиняемся за неудобства, которые могут возникнуть при оформлении заказа на сайте и дарим",
        "10discountOnAllOnlineOrders": "скидку 10% на все онлайн заказы",
        "price": "Цена",
        "show": "Показать",
        "save": "Сохранить",
        "cancel": "Отменить",
        "priceInDescendingOrder": "Цена по убыванию",
        "priceInAscendingOrder": "Цена по возрастанию",
        "doNotSort": "Не сортировать",
        "error": "Ошибка",
        "unfortunatelysomethingWentWrongyouCanContactTheSupportTeamToFindOutWhy": "К сожалению что-то пошло не так, для выяснения причины можете обратиться в службу поддержки",
        "tochkaIsABuildingMaterialsStore": "Точка - магазин строительных материалов",
        "category": "Категории",
        "naturalPerson": "Физическое лицо",
        "legalEntity": "Юридическое лицо",
        "contactPerson": "Контактное лицо",
        "aboutTheLegalEntity": "О юридическом лице",
        "address": "Адрес",
        "delivery": "Доставка",
        "fop_short": "ФЛП",
        "legalEntity_short": "Юр. лицо",
        "tel": "тел",
        "collapse": "Свернуть",
        "NAME": "ФИО",
        "productName": "Название товара",
        "bonuses": "Бонусы",
        "amount": "Сумма",
        "totalBonuses": "Всего бонусов",
        "allAboutTheProduct": "Все о товаре",
        "promotion": "Акция",
        "recoverByEmail": "Восстановить с помощью email",
        "recoverByPhone": "Восстановить с помощью телефона",
        "days": "Дней",
        "hours": "Часов",
        "minutes": "Минут",
        "seconds": "Секунд",
        "thePromotionIsOver": "Акция закончилась",
        "codeOf6Digits": "Код из 6 цифр",
        "productCatalog": "Каталог товаров",
        "theLatest": "Последние",
        "popular": "Популярные",
        "all": "Все",
        "acknowledgments": "Благодарность",
        "remarks": "Замечания",
        "contacts": "Контакты",
        "searchAlert": "Для начала поиска необходимо ввести минимум 3 символа",
        "youCurrentlyHaveNoArchivedOrders": "На данный момент у вас нет архивных заказов",
    },
};

